import React, { useEffect } from "react";
import {
    Button,
    TextField,
    Box,
    Grid2 as Grid,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
// import { showErrorToast, showSuccessToast } from "../../common/util/util";
import { ToastContainer } from "react-toastify";
import { addArea, editArea, getAreaById } from "./Areas.service";
import { useCountryParam, buildUrlWithCountry } from "../../common/util/useCountryParam";

// Validation schema for the form
const validationSchema = yup.object({
    label: yup.string().required("Area is required"),
});

const AddArea = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const country = useCountryParam();
    const [initialValues, setInitialValues] = React.useState({
        label: "",
    });

    useEffect(() => {
        if (id) {
            getAreaById(id).then((res: any) => {
                setInitialValues({
                    label: res.label,
                });
            }).catch(err => console.error(err));
        }
    }, [id]);

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const payload = {
                label: values.label,
                value: values.label.toLowerCase()
            };

            if (id) {
                editArea(payload, id)
                    .then((res: any) => {
                        //   showSuccessToast(res.message);
                        navigate(buildUrlWithCountry("/areas", country));
                    })
                    .catch((err) => {
                        console.error(err.message);
                    });
            } else {
                addArea(payload)
                    .then((res: any) => {
                        //   showSuccessToast(res.message);
                        navigate(buildUrlWithCountry("/areas", country));
                    })
                    .catch((err) => {
                        console.error(err.message);
                    });
            }
        },
    });

    return (
        <Box paddingY={4}>
            <h3>{id ? "Edit Area" : "Add Area"}</h3>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <label htmlFor="label" className="form-label">
                            Area
                        </label>
                        <TextField
                            fullWidth
                            name="label"
                            placeholder="Enter Area"
                            value={formik.values.label}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.label && Boolean(formik.errors.label)
                            }
                            helperText={formik.touched.label && formik.errors.label}
                        />
                    </Grid>

                    <Grid
                        size={{ xs: 12, md: 12 }}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        <Button component={Link} to={buildUrlWithCountry("/areas", country)} color="secondary">
                            Cancel
                        </Button>
                        <Button type="submit" color="primary" variant="contained">
                            {id ? "Update Area" : "Add Area"}
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <ToastContainer position="top-right" autoClose={3000} />
        </Box>
    );
};

export default AddArea;
